import { useTranslation } from 'react-i18next';

interface Props {
  locked: boolean;
  onChange: (locked: boolean) => void;
}

/**
 * ADR-0010: whether a stop's hour is an anchor. Was a lone "Fixed time"
 * checkbox, which said nothing about what happens when it is unticked — both
 * states are named here, each with its consequence.
 */
export default function TimeModeToggle({ locked, onChange }: Props) {
  const { t } = useTranslation();
  const options = [
    { value: false, label: t('itinerary.schedule.modeAuto') },
    { value: true,  label: t('itinerary.schedule.modeFixed') },
  ];

  return (
    <div className="mt-2">
      <div role="radiogroup" aria-label={t('itinerary.schedule.timeMode')} className="inline-flex p-0.5 rounded-full bg-slate-100 dark:bg-slate-800">
        {options.map(opt => {
          const active = opt.value === locked;
          return (
            <button
              key={opt.label}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onChange(opt.value)}
              className={`text-2xs font-semibold px-2.5 py-1 rounded-full transition-colors cursor-pointer ${
                active
                  ? 'bg-white dark:bg-slate-600 text-slate-800 dark:text-white shadow-sm'
                  : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
      <p className="mt-1 text-2xs text-slate-400 leading-relaxed">
        {t(locked ? 'itinerary.schedule.fixedHint' : 'itinerary.schedule.autoHint')}
      </p>
    </div>
  );
}
